import React from "react";
import TAG_TRACKING_DELETE_EVENT from "../../../GraphQl/Mutations/TAG_TRACKING_DELETE_EVENT";
import TAG_TRACKING_UPDATE_EVENTS_TARGET from "../../../GraphQl/Mutations/TAG_TRACKING_UPDATE_EVENTS_TARGET";
import TAG_TRACKING_GET_EVENTS from "../../../GraphQl/Queries/TAG_TRACKING_GET_EVENTS";
import TAG_TRACKING_UPDATE_ACTIVE from "../../../GraphQl/Mutations/TAG_TRACKING_UPDATE_ACTIVE";
import TAG_TRACKING_RESET_AMPLIFY from "../../../GraphQl/Mutations/TAG_TRACKING_RESET_AMPLIFY";
import { useQuery, useMutation, useLazyQuery } from "react-apollo";
import OverlaySpinner from "../../../../platform/shared/OverlaySpinner";
import TrackingController from "./TrackingController";
import CREATE_ORG_MULTI_TAG from "../../../GraphQl/Mutations/CREATE_ORG_MULTI_TAG";
import GET_CART_PROVIDERS from "../../../GraphQl/Queries/GET_CART_PROVIDER";

const TrackingLoader = ({ children, ...props }) => {
  const { orgId } = props;
  const { data: dataMultiOrgTags, loading, error } = useQuery(
    TAG_TRACKING_GET_EVENTS,
    {
      variables: {
        orgId,
      },
    }
  );

  const { data: cartProvidersData } = useQuery(GET_CART_PROVIDERS);

  const [tagTrackingResetAmplify] = useMutation(TAG_TRACKING_RESET_AMPLIFY, {
    variables: {
      orgId,
    },
  });

  const [editMultiOrgTag] = useMutation(TAG_TRACKING_UPDATE_EVENTS_TARGET, {
    variables: {
      orgId,
      cart: props.cart,
      tagUpdateDate: props.tagUpdateDate,
      tagId: props.tagId,
      tag: props.tag,
      name: props.name,
      appId: props.appId,
      isAmplifyDefault: props.isAmplifyDefault,
    },
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query: TAG_TRACKING_GET_EVENTS,
        variables: { orgId },
      },
    ],
  });

  const [getNewMultiOrgTags, { data: newDataMultiOrgTags }] = useLazyQuery(
    TAG_TRACKING_GET_EVENTS,
    {
      variables: { orgId },
    }
  );

  const [deleteMultiOrgTag] = useMutation(TAG_TRACKING_DELETE_EVENT, {
    variables: {
      orgId,
    },
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query: TAG_TRACKING_GET_EVENTS,
        variables: { orgId },
      },
    ],
  });

  const [updateActiveEventsTarget] = useMutation(TAG_TRACKING_UPDATE_ACTIVE, {
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query: TAG_TRACKING_GET_EVENTS,
        variables: { orgId },
      },
    ],
  });

  const [createMultiOrg] = useMutation(CREATE_ORG_MULTI_TAG, {
    variables: {
      orgId,
      cart: props.cart,
      appId: props.appId,
      tagUpdateDate: props.tagUpdateDate,
      tag: props.tag,
      name: props.name,
    },
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query: TAG_TRACKING_GET_EVENTS,
        variables: { orgId },
      },
    ],
  });

  if (error) console.log(error);
  if (loading) {
    return <OverlaySpinner />;
  }

  return (
    <TrackingController
      {...props}
      dataMultiOrgTags={dataMultiOrgTags.org.eventsTarget}
      newDataMultiOrgTags={newDataMultiOrgTags}
      tagTrackingResetAmplify={tagTrackingResetAmplify}
      editMultiOrgTag={editMultiOrgTag}
      getNewMultiOrgTags={getNewMultiOrgTags}
      deleteMultiOrgTag={deleteMultiOrgTag}
      createMultiOrg={createMultiOrg}
      updateActiveEventsTarget={updateActiveEventsTarget}
      cartProvidersData={
        cartProvidersData && cartProvidersData.getCartProviders
      }
    >
      {children}
    </TrackingController>
  );
};

export default TrackingLoader;
